import { CheckCircleOutlined } from "@ant-design/icons";
import upperFirst from "lodash/upperFirst";
import { useTranslation } from "next-i18next";

import styles from "./CartSteps.module.scss";

const CustomSteps = ({ current, ...settings }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.new}>
      <div className={styles.step + " " + (current == 1 ? styles.active : "")}>
        <h4>{current > 1 ? <CheckCircleOutlined /> : "1."}</h4>
        <span>{upperFirst(t("cart:cart"))}</span>
      </div>
      <div className={styles.step + " " + (current == 2 ? styles.active : "")}>
        <h4>{current > 2 ? <CheckCircleOutlined /> : "2."}</h4>
        <span>{upperFirst(t("cart:contact info"))}</span>
      </div>
      <div className={styles.step + " " + (current == 3 ? styles.active : "")}>
        <h4>{current > 3 ? <CheckCircleOutlined /> : "3."}</h4>
        <span>{upperFirst(t("cart:delivery and payment"))}</span>
      </div>
      <div className={styles.step + " " + (current == 4 ? styles.active : "")}>
        <h4>{current > 4 ? <CheckCircleOutlined /> : "4."}</h4>
        <span>{upperFirst(t("cart:order completion"))}</span>
      </div>
    </div>
  );
};

const CartSteps = ({ current = 1, options = {} }) => {
  const settings = {
    style: { textAlign: "left" },
    size: "small",
    initial: 0,
    labelPlacement: "vertical",
    ...options,
  };

  return (
    <>
      <CustomSteps current={current} {...settings} />
    </>
  );
};

export default CartSteps;
